import { AfterViewInit, Component, Inject, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UserUploadManagementService } from 'src/app/modules/admin/user-upload-management/user-upload-management.service';
import { ProfileFileTabHistoryComponent } from '../profile-file-tab-history/profile-file-tab-history.component';
import { DateTimeFormatPipe } from 'src/app/shared/pipes/date-time-format.pipe';
import { NbToastrService } from '@nebular/theme';
import { HotToastService } from '@ngneat/hot-toast';
import { PrimasTableComponent } from '../../../template-management/primas-table/primas-table.component';
import { FileShareModel } from 'src/app/modules/admin/user-upload-management/user-upload.model';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

@Component({
  selector: 'app-ProfileFileTabShare',
  templateUrl: './profile-file-tab-share.component.html',
  styleUrls: ['./profile-file-tab-share.component.scss']
})
export class ProfileFileTabShareComponent implements OnInit {
    @ViewChild('profileShareFileTable') profileShareFileTable: PrimasTableComponent;
    @ViewChild('fileNameCol', { static: true }) fileNameCol: TemplateRef<any>;
    @Input() userUploadHistoryId: string;
    @Input() showBottomAction: boolean = false
    @Input() referenceId: string;;
    @Input() isAllowed: boolean = true;
    @Input() resource;
    downloading = false;
    downloadPercent = 0;
    selectedRowIndex = -1;
    columns = []; 
    isLoading = false;
 constructor(
     private service: UserUploadManagementService,
     private dateTimeFormatPipe: DateTimeFormatPipe,
     @Inject(MAT_DIALOG_DATA) public data: any,
     private toast: NbToastrService,
     private dialogRef: MatDialogRef<ProfileFileTabHistoryComponent>,
     private hotToast: HotToastService,
   ) {
     this.showBottomAction = data.showBottomAction ?? this.showBottomAction
     this.userUploadHistoryId = data.userUploadHistoryId ?? this.userUploadHistoryId;
     this.referenceId = data.referenceId ?? this.referenceId;
     this.isAllowed = data.isAllowed ?? this.isAllowed;
     this.resource = data.resource ?? this.resource;
   }

  ngOnInit() {
    this.columns = [
      {
        name: "Date Modified",
        prop: "dateModified",
        pipe: this.dateTimeFormatPipe,
        sortable: false,
        filter: false,
      },
      {
        name: 'File Name',
        prop: 'userUpload.fileName',
        filter: false,
        import: false,
        sortable: false,
        cellTemplate: this.fileNameCol
      },
    ];
  }
  refreshData(reset: boolean = false): void {
    this.profileShareFileTable.isLoading = 1;
    var offSetX = this.profileShareFileTable.table.bodyComponent.offsetX;

    if (reset) {
      this.profileShareFileTable.page.pageNumber = 0;
      this.profileShareFileTable.cache = {};
      this.profileShareFileTable.rows = [];
      this.profileShareFileTable.selected = [];
      this.profileShareFileTable.table.offset = 0;
      this.profileShareFileTable.table.bodyComponent._offset = 0;
      offSetX = 0;
    }
    this.profileShareFileTable.page.size = -1;
    this.service.getUserUploadHistoryPagingById(this.profileShareFileTable.page, this.userUploadHistoryId, this.referenceId).subscribe((resp) => {
      if (resp) {
        this.profileShareFileTable.setData(resp.result);
        // Set the default selected items.
        // If every item is already selected, enable the "Select All" toggle
        // so it can later be used to deselect everything.
        this.profileShareFileTable.selected = resp.result.data.filter(userUploadHistory => userUploadHistory.userUpload.shareAble);
        setTimeout(() => {
          this.profileShareFileTable.table.recalculate();
          this.profileShareFileTable.table['cd'].markForCheck();
          document.body.style.width = 'auto';
          this.profileShareFileTable.table._offsetX.next(offSetX);
        }, 200);
      }
      this.profileShareFileTable.isLoading = 0;
    })
  }
  onToggleSelectAll() {
    if (!(this.profileShareFileTable.selected.length === this.profileShareFileTable.rows.length))
    {
      this.profileShareFileTable.selected = [...this.profileShareFileTable.rows];
    } else {
      this.profileShareFileTable.selected = [];
    }
  
  }
  onShare() {
    this.isLoading = true;
    const model: FileShareModel = {
      referenceId: this.referenceId,
      userUploadHistoryId: this.userUploadHistoryId,
      fileIds:this.profileShareFileTable.selected.length > 0 ? this.profileShareFileTable.selected?.map(item => item?.userUpload?.userUploadId) : []
    }
    this.service.shareFile(model).subscribe((resp) => {
      this.isLoading = false;
      if(resp.result) {
        this.hotToast.success('The operation succeeded!', { duration: 2000 });
        this.dialogRef.close(true);
      }
    })
  }
  closeDialog() {
    this.dialogRef.close(false);
  }
}
